import { render, staticRenderFns } from "./cWxOpenSubscribeBtn.vue?vue&type=template&id=4d77f7e0"
import script from "./cWxOpenSubscribeBtn.vue?vue&type=script&lang=js"
export * from "./cWxOpenSubscribeBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports